/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { UserService } from '../../services/user.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {

  profileEdit: boolean = false;
  firstName: string = ''; 
  lastName: string = '';
  emailId: string = '-';
  selected = 'Table';
  userForm: FormGroup;

  isPasscodeOpen:boolean=false;
  user: any = {};
  firstNameError: string = "";
  lastNameError: string = "";
  emailNameError: string = "";
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  @Output() openModal: EventEmitter<void> = new EventEmitter();
  constructor(private modalController: ModalController, private userService: UserService, private utilService: UtilsService) {
    this.userForm = new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]),
      emailId: new FormControl(''),
    });
   
  }

  ngOnInit() {
    this.user = this.userService.getUser(); 
    this.selected=this.userService.getAnswerMode();
    this.splitFullName();
  }

  editProfile() {
    this.profileEdit = !this.profileEdit;
  }

  modalDismiss() {
    this.modalController.dismiss(); 
  }

  splitFullName() {
    const [firstName, ...lastNameParts] = this.user.name.trim().split(' ');
    this.userForm.controls['firstName'].setValue(firstName);
    this.userForm.controls['lastName'].setValue(lastNameParts.join(' '));
  }

  saveDetails() {
    this.updateErrorMessages();
    if (this.userForm.valid) {
      const name = this.userForm.value.firstName + ' ' + this.userForm.value.lastName;
      Object.assign(this.user, { name: name });
      const updatedUserDetails = Object.values(this.user);
      this.profileEdit = !this.profileEdit;
      this.userService.setUser(...(updatedUserDetails as [string, number, number, boolean]));
      this.userService.setAnswerMode(this.selected);
      this.utilService.setUserLogoText();
    }
    this.userService.setAnswerMode(this.selected)
    this.utilService.updatedChatMessages = this.utilService.updatedChatMessages.map(message => {
      if (!message.isUser) {
        return {
          ...message,
          answerMode: this.userService.getAnswerMode()
        };
      }
      return message;
    });
    
  }

  cancel() {
    
    this.profileEdit = !this.profileEdit;
    this.splitFullName();
    this.firstNameError = this.lastNameError=this.emailNameError= "";
    this.selected=this.userService.getAnswerMode();
  }

  // Method to update error messages dynamically
  updateErrorMessages() {
    // Update error message for firstName
    if (this.userForm.get('firstName')?.hasError('required') && this.userForm.get('firstName')?.touched) {
      this.firstNameError = "First name is required";
    } else if (this.userForm.get('firstName')?.hasError('pattern') && this.userForm.get('firstName')?.touched) {
      this.firstNameError = "First name should only contain letters";
    } else {
      this.firstNameError = "";
    }

    // Update error message for lastName
    if (this.userForm.get('lastName')?.hasError('required') && this.userForm.get('lastName')?.touched) {
      this.lastNameError = "Last name is required";
    } else if (this.userForm.get('lastName')?.hasError('pattern') && this.userForm.get('lastName')?.touched) {
      this.lastNameError = "Last name should only contain letters";
    } else {
      this.lastNameError = "";
    }

    // Update error message for emailId (Optional, can be extended with specific email validation if needed)
    if (this.userForm.get('emailId')?.hasError('email') && this.userForm.get('emailId')?.touched) {
      this.emailNameError = "Please enter a valid email";
    } else if (this.userForm.get('emailId')?.hasError('required') && this.userForm.get('emailId')?.touched) {
      this.emailNameError = "Email id is required";
    } else {
      this.emailNameError = "";
    }
  }
  profileDismiss(){
    this.closeModal.emit();
  }
  passcodeOpen(){
    this.openModal.emit();
  }
 

}
